<template>
    <!-- Env / version strip — only renders when there's something to show
         (non-prod env, ZynoWorkstation runtime version, or app version). Kept
         separate from the user strip so the in-app sidebar can drop the user
         banner while still surfacing the build version. -->
    <div v-if="versionLabel" class="zs-sidebar-version" :class="{ 'is-nonprod': !isProduction }">
        {{ versionLabel }}
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const isProduction = import.meta.env.VITE_APP_ENV === 'production';
const versionLabel = computed(() => {
    const zwVersion = navigator.userAgent.match(/^Zyno(Desktop|Workstation)\/([\d.]+)/)?.[2]?.replace(/\.0$/, '');
    const parts: string[] = [];
    if (!isProduction) parts.push(String(import.meta.env.VITE_APP_ENV));
    if (zwVersion) parts.push(zwVersion);
    if (import.meta.env.VITE_APP_VERSION) parts.push(String(import.meta.env.VITE_APP_VERSION));
    return parts.join(' · ');
});
</script>
